import React, { useState } from 'react';
import styled from 'styled-components';
import { Dialog, ElevatedButton, TextButton } from '@producer/ui-kit';

export type DeleteDialogProps = {
  onCancel: () => void;
  onSubmit: () => void;
  text: string;
  title: string;
  actionText?: string;
};

export const DeleteDialog: React.FC<DeleteDialogProps> = ({
  onCancel,
  onSubmit,
  text,
  title,
  actionText = 'Yes, delete',
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    if (isLoading) {
      return;
    }

    setIsLoading(true);

    try {
      await onSubmit();
      setIsLoading(false);
      onCancel();
    } catch (e) {
      setIsLoading(false);
    }
  };

  return (
    <Dialog
      title={title}
      onClose={onCancel}
      actions={[
        <TextButton key="cancel" text="Cancel" onClick={onCancel} />,
        <ElevatedButton
          key="delete"
          isLoading={isLoading}
          disabled={isLoading}
          onClick={handleSubmit}
          text={actionText}
          variant="danger"
          autoFocus
        />,
      ]}
    >
      <Container>{text}</Container>
    </Dialog>
  );
};

const Container = styled.p`
  color: var(--color-grayscale-light-slate);
  white-space: pre-line;
`;
